import { makeStyles } from '@material-ui/core/styles';
import { ERebrandingColors } from 'helpers/constants';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: '#fff',
  },
  spinContainer: {
    width: '100%',
    textAlign: 'center',
  },
  searchField: {
    maxWidth: 500,
  },
  card: {
    padding: theme.spacing(2),
    position: 'relative',
    height: '100%',
  },
  title: {
    fontSize: '1.2rem',
    color: ERebrandingColors.MAIN,
    marginBottom: theme.spacing(1),
    fontWeight: 700,
  },
  emptyList: {
    padding: theme.spacing(2),
  },
  options: {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
  },
  privileges: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  privilegeContainer: {
    flexBasis: `calc(50% - ${theme.spacing(1) * 2}px)`,
    '& p': {
      fontWeight: 500,
      fontSize: '0.875rem',
      marginBottom: theme.spacing(0.5),
    },
    '& ul': {
      listStyle: 'none',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
    },
  },
  search: {
    [theme.breakpoints.up('md')]: {
      marginTop: '-66px',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  searchInput: {
    marginTop: `- ${theme.spacing(2)}px`,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
}));
